import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {Balise} from "@domain/admin/bibliotheque/notification/balise";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService} from "@services/admin/bibliotheque/notification.service";
import {handleResult} from "@share/utils/handle-result";
import {ToastrService} from "ngx-toastr";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {filter} from "rxjs/operators";

/**
 * Composant d'affichage des items de la liste
 *
 * @author Lionel Gimenez
 * @date 10/03/2026
 */
@Component({
    host: {'data-test-id': 'balise-item'},
    selector: 'balise-item',
    templateUrl: './balise-item.component.html'
})
export class BaliseItemComponent extends ListViewItem<Balise> {
    /**
     * Constructeur
     */
    constructor(
        public translateService: TranslateService,
        public notificationService: NotificationService,
        public toastrService: ToastrService,
        private confirmService: ConfirmService,
    ) {
        super();
    }

    /**
     * Tronque la description aux 150 premiers caractères et à la première ligne
     *
     * @param description Description à tronquer
     * @returns Description tronquée
     */
    getTruncatedDescription(description: string): string {
        if (!description) {
            return '';
        }
        //Récupération de la première ligne
        const firstLineIndex = description.indexOf('\n');
        const firstLine = firstLineIndex > -1 ? description.substring(0, firstLineIndex) : description;
        //Limitation à 150 caractères
        return firstLine.substring(0, 150);
    }

    /**
     * Handler du delete
     */
    onDelete(): void {
        //Confirmation
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe(() => {
                //Suppression de la balise
                this.notificationService.deleteBalise(this.data.idBalise)
                    .pipe(handleResult(this.translateService,this.toastrService,'global.success.suppression','global.errors.suppression'))
                    .subscribe(() => this.liste.refresh());
            });
    }
}
